<template>
    <confirmation-dialogue v-slot:default="cd" v-bind:id="'contract-annex-deliverable-duplicate-remove-confirmation-popup'">
        <on-off v-slot:default="onoff" v-bind:options="{ id: cd.$props.id, onEsc: false, onBody: false }">
            <div v-if="onoff.ison" class="atmo-popup-wrapper">
                <div class="atmo-popup-content">
                    <button v-on:click.stop="cd.cancel" class="atmo-button--small atmo-close"><i class="atmo-icon-close"></i></button>

                    <header>
                        <p v-text="cd.item"></p>

                        <h5>Подтвердите удаление дубликата позиции спецификации</h5>
                    </header>

                    <main>
                        <p>Вы действительно хотите удалить этот дубликат позиции спецификации?</p>
                    </main>

                    <footer>
                        <ul class="atmo-buttons atmo-align-right">
                            <li><button v-on:click="cd.cancel" class="atmo-button">Отмена</button></li>
                            <li><button v-on:click="cd.confirm" class="atmo-button atmo-accented">Удалить</button></li>
                        </ul>
                    </footer>
                </div>
            </div>
        </on-off>
    </confirmation-dialogue>
</template>

<script>
import OnOff from '@lib/js/src/vue/components/OnOffV6.component.js';
import ConfirmationDialogue from '@lib/js/src/vue/components/ConfirmationDialogue.viewmodel.ts';

export default {
    components: {
        'on-off': new OnOff(),
        'confirmation-dialogue': ConfirmationDialogue
    }
};
</script>
